import { render, staticRenderFns } from "./VeJwCjQingkaoList.vue?vue&type=template&id=35b232d3&scoped=true"
import script from "./VeJwCjQingkaoList.vue?vue&type=script&lang=js"
export * from "./VeJwCjQingkaoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b232d3",
  null
  
)

export default component.exports